import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { X, Plus } from 'react-bootstrap-icons'

// New emails get attached to every influencer currently checked below.
export default observer(function RecipientEmailsSection({ checkedGroups, manualEmailsByInfluencer, onAddEmail, onRemoveEmail }) {
  const [emailInput, setEmailInput] = useState('')

  const chips = checkedGroups.flatMap(({ influencer }) => [
    ...(influencer.email ? [{ key: `${influencer.id}-default`, email: influencer.email, removable: false }] : []),
    ...(manualEmailsByInfluencer[influencer.id] || []).map(email => (
      { key: `${influencer.id}-${email}`, email, influencerId: influencer.id, removable: true }
    )),
  ])

  const addEmail = () => {
    const email = emailInput.trim()
    if (!email || checkedGroups.length === 0) return

    checkedGroups.forEach(({ influencer }) => onAddEmail(influencer.id, email))
    setEmailInput('')
  }

  return (
    <div className="mb-4">
      <p className="font-bold mb-2 dark:text-white">Recipient Emails</p>

      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {chips.map(chip => (
            <span key={chip.key} className="flex items-center gap-1 px-2 py-1 text-xs rounded-lg bg-gray-100 dark:bg-rb-dark-mode-lighter dark:text-white">
              {chip.email}
              {chip.removable && (
                <button onClick={() => onRemoveEmail(chip.influencerId, chip.email)}><X className="text-xs" /></button>
              )}
            </span>
          ))}
        </div>
      )}

      <div className="flex gap-2">
        <input
          type="email"
          value={emailInput}
          onChange={e => setEmailInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && addEmail()}
          disabled={checkedGroups.length === 0}
          placeholder={checkedGroups.length === 0 ? 'Select a recipient below first' : 'Add another recipient email'}
          className="flex-1 p-2 text-sm border-1 border-rb-lite-grey rounded-lg focus:ring-transparent focus:border-rb-green dark:bg-rb-dark-mode dark:text-white dark:border-rb-dark-mode-lighter disabled:opacity-50"
        />
        <button onClick={addEmail} disabled={checkedGroups.length === 0} className="px-3 text-white bg-rb-green rounded-lg disabled:opacity-50">
          <Plus />
        </button>
      </div>
    </div>
  )
})
